import { render, staticRenderFns } from "./ruralRoadBigData.vue?vue&type=template&id=230e94e2&scoped=true"
import script from "./ruralRoadBigData.vue?vue&type=script&lang=js"
export * from "./ruralRoadBigData.vue?vue&type=script&lang=js"
import style0 from "./ruralRoadBigData.vue?vue&type=style&index=0&id=230e94e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e94e2",
  null
  
)

export default component.exports